module.exports = [{"value":"ภาษาเกาหลี","text":"ภาษาเกาหลี"},{"value":"ภาษาญี่ปุ่น","text":"ภาษาญี่ปุ่น"},{"value":"ภาษาเยอรมัน","text":"ภาษาเยอรมัน"},{"value":"ภาษาสเปน","text":"ภาษาสเปน"},{"value":"ภาษาฝรั่งเศส","text":"ภาษาฝรั่งเศส"},{"value":"ภาษาอังกฤษ","text":"ภาษาอังกฤษ"},{"value":"ภาษาจีน","text":"ภาษาจีน"},{"value":"ภาษาไทย","text":"ภาษาไทย"},{"value":"ภาษาเขมร","text":"ภาษาเขมร"},{"value":"ภาษามาเลย์","text":"ภาษามาเลย์"},{"value":"ภาษาเวียดนาม","text":"ภาษาเวียดนาม"},{"value":"ภาษาลาว","text":"ภาษาลาว"},{"value":"ภาษาพม่า","text":"ภาษาพม่า"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/master/LanguageSkill/LanguageSkillTH.json
// module id = GiMu
// module chunks = 2